/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ElectricalSettingsReturnCodes{
    Success = 0,
    KeyCombinationAlreadyAssigned = 1,
    KeyCombinationAnotherApplication = 2,
    KeyCombinationExistInRevit = 3,
    InvalidShortcutsOpening = 4
}